import { render, staticRenderFns } from "./form-user-add.vue?vue&type=template&id=0947df51&"
import script from "./form-user-add.vue?vue&type=script&lang=js&"
export * from "./form-user-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports